module.exports = __webpack_public_path__ + "media/preview/webinar@4x-469135a9.png";